import { type ReactNode } from 'react'
import cx from 'classnames'
import styles from './StepList.module.css'
import { Icon } from '@/components/Icon'

export interface StepListProps {
  children?: ReactNode
  testId?: string
}

/**
 * A list of steps to be followed.
 */
export function StepList({ children, testId }: StepListProps) {
  return (
    <ul data-test={testId} className={cx(styles.root)}>
      {children}
    </ul>
  )
}

interface StepProps {
  children?: ReactNode
  state: 'pending' | 'current' | 'completed'
  step: number
  title: ReactNode
  testId?: string
}

/**
 * A step in the list.
 */
export function Step({ state, step, title, children, testId }: StepProps) {
  return (
    <li
      className={styles.step}
      data-test={testId}
      aria-current={state === 'current' ? 'step' : undefined}
    >
      <div
        className={cx(
          styles.stepDecoration,
          state === 'current' && styles.current,
          state === 'completed' && styles.completed,
        )}
      >
        <div className={styles.stepProgressMarker}>
          {state === 'completed' ? (
            <Icon sm variant="inherit" name="done" />
          ) : (
            <span className={styles.stepNumber}>{step}</span>
          )}
        </div>
        <div className={styles.stepLine} />
      </div>
      <div className={styles.stepContent}>
        <p className={styles.stepTitle}>{title}</p>
        <p className={styles.stepDescription}>{children}</p>
      </div>
    </li>
  )
}
